<template>
  <page-section :title="$t('Integrations_Overview_Information')">
    <form-section>
      <b>{{ $t('Integrations_Lithium_Field_Url') }}</b>
      : {{ model.params.url }}
    </form-section>
    <integration-tasks-table
      :integration-id="model.id"
      :task-identifiers="['lithium_v2_promotions_sync']"
    />
  </page-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import IntegrationTasksTable from '@/modules/integrations/components/IntegrationTasksTable'
import PageSection from '@/common/components/page/PageSection'

export default {
  name: 'LithiumV2Overview',

  components: {
    PageSection,
    IntegrationTasksTable,
    FormSection
  },

  props: {
    model: {
      required: false
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/lithiumv2/LithiumV2Overview.vue